<template>
    <b-nav-item @click="toggle" class="mr-2">
        <font-awesome-icon
            :icon="fullscreen ? 'compress' : 'expand'"
        ></font-awesome-icon>
    </b-nav-item>
</template>

<script>
export default {
  name: "FullScreenToggle",
  data() {
    return {
      fullscreen: false
    };
  },
  methods: {
    toggle() {
      this.$fullscreen.toggle(document.body, {
        wrap: true,
        callback: this.fullscreenChange,
        fullscreenClass: "fullscreen"
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    }
  }
};
</script>
